const ErrorPage = () => {
  return (
    <div className="flex items-center justify-center bg-gray-100 py-5">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-800">404</h1>
        <p className="text-2xl font-semibold text-gray-600 mb-4">Page Not Found</p>
        <p className="text-gray-500">Sorry, the page you are looking for does not exist.</p>
      </div>
    </div>
  );
};

export default ErrorPage;
